import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { OutboundEmail } from '@erp/rpc';

/**
 * Hook to fetch an outbound email by ID
 */
export function useOutboundEmail(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.communications.outboundEmails.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    outboundEmail: query.data ?? null,
  } satisfies typeof query & {
    data?: OutboundEmail | null;
    outboundEmail: OutboundEmail | null;
  };
}
